var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isStoreReady)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100vh"}},[_c('p',[_vm._v("Carregando...")])]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }